import { Component } from "preact";
import Modal from "./modal";

const translationLV = {
  BERTHED: "Ostā",
  EXPECTED: "Plānots",
  MOVING: "Kustībā",
  RAID: "Reidā",
};

const translationRU = {
  BERTHED: "В ПОРТУ ",
  EXPECTED: "ОЖИДАЕТСЯ",
  MOVING: "В ДВИЖЕНИЕ",
  RAID: "В РЕЙД",
};

/* List of country Alpha-2 values */
const countryMap = {
  AE: "United Arab Emirates",
  AF: "Afghanistan",
  AG: "Antigua and Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "American Samoa",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Aland Islands",
  AZ: "Azerbaijan ",
  BA: "Bosnia and Herzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthelemy",
  BM: "Bermuda",
  BN: "Brunei Darussalam",
  BO: "Bolivia",
  BQ: "BONAIRE SAINT EUSTATIUS AND SABA",
  BR: "Brazil",
  BS: "Bahamas",
  BV: "Bouvet Island",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Cocos (Keeling) Islands",
  CD: "Congo, The Democratic Republic of the",
  CF: "Central African Republic",
  CG: "Congo",
  CH: "Switzerland",
  CI: "Côte d'Ivoire",
  CK: "Cook Islands",
  CL: "Chile",
  CM: "Cameroon",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cape Verde",
  CW: "Curacao",
  CX: "Christmas Island",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DE: "Germany",
  DJ: "Djibouti",
  DK: "Denmark",
  DM: "Dominica",
  DO: "Dominican Republic",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egypt",
  EH: "Western Sahara ",
  ER: "Eritrea",
  ES: "Spain",
  ET: "Ethiopia",
  EU: "European Bodies",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands (Malvinas)",
  FM: "Micronesia, Federated States of",
  FO: "Faroe Islands",
  FR: "France",
  GA: "Gabon",
  GB: "United Kingdom",
  GD: "Grenada",
  GE: "Georgia",
  GF: "French Guiana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Equatorial Guinea",
  GR: "Greece",
  GS: "South Georgia and the South Sandwich Islands",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Heard Island and McDonald Islands",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "India",
  IO: "British Indian Ocean Territory",
  IQ: "Iraq",
  IR: "Iran, Islamic Republic of",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KH: "Cambodia",
  KI: "Kiribati",
  KM: "Comoros",
  KN: "Saint Kitts and Nevis",
  KP: "Korea, Democratic People's Republic of",
  KR: "Korea, Republic of",
  KW: "Kuwait",
  KY: "Cayman Islands",
  KZ: "Kazakhstan",
  LB: "Lebanon",
  LC: "Saint Lucia",
  LK: "Sri Lanka",
  LR: "Liberia",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  LY: "Libyan Arab Jamahiriya",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova, Republic of",
  ME: "Montenegro",
  MF: "Saint Martin (French Part)",
  MG: "Madagascar",
  MH: "Marshall Islands",
  MK: "Macedonia, The former Yugoslav Republic of",
  MM: "Myanmar",
  MO: "Macao",
  MP: "Northern Mariana Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "New Zealand",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "French Polynesia ",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PM: "Saint Pierre and Miquelon",
  PN: "Pitcairn",
  PR: "Puerto Rico",
  PS: "Palestine, State Of",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russian Federation",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SB: "Solomon Islands",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Sweden",
  SG: "Singapore",
  SH: "Saint Helena",
  SI: "Slovenia",
  SJ: "Svalbard and Jan Mayen",
  SK: "Slovakia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  ST: "Sao Tome and Principe",
  SV: "El Salvador",
  SX: "Saint Martin (Dutch part)",
  SY: "Syrian Arab Republic",
  SZ: "Swaziland",
  TC: "Turks and Caicos Island",
  TF: "French Southern Territories",
  TG: "Togo",
  TH: "Thailand",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turkey",
  TT: "Trinidad and Tobago",
  TV: "Tuvalu",
  TW: "Taiwan, Province of China",
  TZ: "Tanzania, United Republic of",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "United States Minor Outlying Islands",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VC: "Saint Vincent and the Grenadines",
  VE: "Venezuela",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  VN: "Viet Nam",
  VU: "Vanuatu",
  WF: "Wallis and Futuna",
  WS: "Samoa",
  XX: "EMSA",
  XZ: "Installations in International Waters",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  ZZ: "ZZ exceptional",
};

/* Ordering order for ship status when no GT sorters are selected */
const sortingOrder = ["BERTHED", "EXPECTED", "MOVING", "RAID"];

export default class Ships extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: this.props.items,
      modalVisible: false,
      modalShip: null,
    };
  }

  /**
   * Renders berth field based on it's value
   
   * @param {object} ship - instance of ship in the list
   */
  displayBerthData = (ship) => {
    if (ship.Statuss === "BERTHED") {
      if (ship.PasreizejaPiestatne) {
        return (
          <>
            <dt>
              {this.props.language === "lv"
                ? "Piestātne"
                : this.props.language === "en"
                ? "Berth"
                : "Причал"}
            </dt>
            <dd>{ship.PasreizejaPiestatne}</dd>
          </>
        );
      } else {
        return <dt></dt>;
      }
    } else if (ship.Statuss === "RAID") {
      if (ship.PiestatneUz === "OUT") {
        return (
          <>
            <dt>
              {this.props.language === "lv"
                ? "Piestātne"
                : this.props.language === "en"
                ? "Berth"
                : "Причал"}
            </dt>
            <dd>
              {this.props.language === "lv"
                ? "Kuģis pamet ostu"
                : this.props.language === "en"
                ? "Ship is leaving port"
                : "Kорабль выходит из порта"}
            </dd>
          </>
        );
      } else if (ship.PiestatneUz) {
        return (
          <>
            <dt>
              {this.props.language === "lv"
                ? "Uz piestātni"
                : this.props.language === "en"
                ? "To berth"
                : "До причала"}
            </dt>
            <dd>{ship.PiestatneUz}</dd>
          </>
        );
      } else {
        return <dt></dt>;
      }
    } else {
      if (ship.PiestatneUz === "OUT") {
        return (
          <>
            <dt>
              {this.props.language === "lv"
                ? "Piestātne"
                : this.props.language === "en"
                ? "Berth"
                : "Причал"}
            </dt>
            <dd>
              {this.props.language === "lv"
                ? "Kuģis pamet ostu"
                : this.props.language === "en"
                ? "Ship is leaving port"
                : "Kорабль выходит из порта"}
            </dd>
          </>
        );
      } else if (ship.PiestatneUz) {
        return (
          <>
            <dt>
              {this.props.language === "lv"
                ? "Uz piestātni"
                : this.props.language === "en"
                ? "To berth"
                : "До причала"}
            </dt>
            <dd>{ship.PiestatneUz}</dd>
          </>
        );
      } else {
        return <dt></dt>;
      }
    }
  };

  /**
   * Returns image request url based on ship ID
   *
   * @param {number} id - ship ID
   * @returns {string} url of image API
   */
  getImageLink = (id) => {
    return "https://oks.rop.lv/api/v1/ships/" + id + "/image";
  };

  /**
   * Sends out the request for ship image
   *
   * @param {number} id - ship ID
   * @returns {string} url of image
   */
  getShipImage = (id) => {
    $.ajax({
      url: getImageLink(id),
      dataType: "json",
      success: function (result) {
        return result;
      },
    });
  };

  /**
   * Returns string containing ship size info
   *
   * @param {object} ship - instance of ship
   * @returns {string} renderable string containing ship size
   */
  getShipSize = (ship) => {
    if (ship.garums || ship.platums) {
      return (ship.garums ?? `-`) + ` x ` + (ship.platums ?? `-`) + ` m`;
    } else {
      return `-`;
    }
  };

  /**
   * Returns string for the case when no ships are returned from the API
   *
   * @returns {string} string containing info in specified language
   */
  renderNoShips = () => {
    return this.props.language === "lv"
      ? "Šajā sadaļā kuģu šobrīd nav"
      : this.props.language === "en"
      ? "No ships currently in this section"
      : "В настоящее время в этом разделе нет судов";
  };

  /**
   * Sorts and filters the ship list based on values given in props
   *
   * @returns {Array} list of sorted and filtered ships
   */
  sortShips = () => {
    var tempShips = JSON.parse(JSON.stringify(this.state.items));

    /* In case no additional sorting is done, ships are sorted by their status and GT values */
    tempShips = tempShips.sort((a, b) => {
      let comparisionValue =
        sortingOrder.indexOf(a.Statuss) - sortingOrder.indexOf(b.Statuss);
      if (comparisionValue !== 0) {
        return comparisionValue;
      } else {
        return b.GT - a.GT;
      }
    });

    /* Additional sorting based on user selection */
    if (this.props.gtSort !== "none") {
      tempShips = tempShips.sort((a, b) => {
        return this.props.gtSort === "desc"
          ? parseFloat(b.GT, 10) - parseFloat(a.GT, 10)
          : parseFloat(a.GT, 10) - parseFloat(b.GT, 10);
      });
    }

    /* List filtering */
    if (this.props.shipFilter !== "all") {
      tempShips = tempShips.filter((ship) => {
        return ship.Statuss === this.props.shipFilter;
      });
    }

    /* Creating renderable list */
    return tempShips.map((ship) => {
      return (
        <li
          onClick={() => this.setState({ modalVisible: true, modalShip: ship })}
        >
          <div class="ship-image-div">
            <img
              alt=""
              src={
                ship.FailaId
                  ? this.getImageLink(ship.id)
                  : ship.marineTrafficUrl
                  ? ship.marineTrafficUrl
                  : "/img/ships/placeholder.jpg"
              }
            />
          </div>
          <div class="title">
            <span>{ship.nosaukums}</span>
          </div>
          <div class="badge">{}</div>
          <div class="badge">
            {this.props.language === "lv"
              ? translationLV[ship.Statuss]
              : this.props.language === "en"
              ? ship.Statuss
              : translationRU[ship.Statuss]}
          </div>

          <dl class="features">
            <dt>
              {this.props.language === "lv" || this.props.language === "en"
                ? "IMO"
                : "ИМО"}
            </dt>
            <dd>{ship.Imo && ship.Imo != "" ? ship.Imo : `-`}</dd>
            <dt>
              {this.props.language === "lv"
                ? "Karogs"
                : this.props.language === "en"
                ? "Flag"
                : "Флаг"}
            </dt>
            <dd>
              {countryMap[ship.Karogs]
                ? countryMap[ship.Karogs]
                : ship.Karogs ?? `-`}
            </dd>
            <dt>
              {this.props.language === "lv" || this.props.language === "en"
                ? "GT"
                : "ВВ"}
            </dt>
            <dd>
              {Math.trunc(ship.GT)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, " ") ?? `-`}
            </dd>
            <dt>
              {this.props.language === "lv"
                ? "Izmērs"
                : this.props.language === "en"
                ? "Size"
                : "Размер"}
            </dt>
            <dd>{this.getShipSize(ship)}</dd>
            <dt>
              {this.props.language === "lv"
                ? "Iegrime"
                : this.props.language === "en"
                ? "Draft"
                : "Oсадка"}
            </dt>
            <dd>{ship.Iegrime ? ship.Iegrime + ` m` : `-`}</dd>
            {this.displayBerthData(ship)}
          </dl>
        </li>
      );
    });
  };

  /**
   * Callback function that sets modal invisible. Get passed to modal component
   */
  closeModal = () => {
    this.setState({ modalVisible: false, modalShip: null });
  };

  /**
   * Renders modal window if modalVisible is set
   *
   * @returns {Modal} modal component
   */
  renderModal = () => {
    if (this.state.modalVisible) {
      var url = new URL(location.href);
      history.replaceState({}, "", url.origin + `/${this.props.language}/kugi-osta#${this.state.modalShip.Imo}`)
      return (
        <Modal
          modalVisible={this.state.modalVisible}
          closeModal={this.closeModal}
          modalShip={this.state.modalShip}
          language={this.props.language}
        />
      );
    }
    return null;
  };

  componentDidMount() {
    let url = window.location.href;
    let index = url.indexOf("#");
    if (index !== -1) {
      let hash = url.substring(index + 1);

      let ship = this.state.items.find((ship) => ship.Imo == hash);

      if (ship) {
        this.setState({ modalVisible: true, modalShip: ship });
      }
    }
  }

  render() {
    var filteredData = this.sortShips();
    if (filteredData.length > 0) {
      return (
        <>
          <ul class="ships-list">{filteredData}</ul>
          {this.renderModal()}
        </>
      );
    } else {
      return <h1 style="text-align:center">{this.renderNoShips()}</h1>;
    }
  }
}
